import { render, staticRenderFns } from "./ConfirmCloseDialog.vue?vue&type=template&id=3456cf58&scoped=true"
import script from "./ConfirmCloseDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmCloseDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmCloseDialog.vue?vue&type=style&index=0&id=3456cf58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3456cf58",
  null
  
)

export default component.exports